import axios from 'axios'
import router from "@/router";

const request = axios.create({
  baseURL: 'https://api.kehui99.cn/app',  // 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
  // timeout: 5000
})

//请求白名单，如果请求在白名单里，将不会呗拦截权限校验
const whiteUrls = ["/admin/login", "/admin/register"]

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json;charset=utf-8';

  //取出sessionStorage里面缓存的用户信息
  // let userJSON=sessionStorage.getItem("user");
  // let tokenJSON=sessionStorage.getItem("token");
  // if(!whiteUrls.includes(config.url)){//检验请求白名单那
  //     if (!userJSON){
  //         router.push("/login")
  //     }else {
  //         let user=JSON.parse(userJSON);
  //         config.headers["token"]=user.token;//设置请求头
  //     }
  // }
  return config
}, error => {
  return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
  response => {
    let res = response.data;
    // 如果是返回的文件
    if (response.config.responseType === 'blob') {
      return res
    }
    // 兼容服务端返回的字符串数据
    if (typeof res === 'string') {
      res = res ? JSON.parse(res) : res
    }
    //验证token
    // if (res.code==='51'||res.code==='52') {
    //     console.error("token已经过期,请重新登入")
    //     router.push("/login")
    // }
    return res;
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)


export default request


